import { Message } from "element-ui";
import Store from "@/lobby_common/store/index";

let vm = null;
export function sendUtilThis(_this) {
  vm = _this;
}

export function debounce(func, wait, immediate) {
  let timeout;
  let context;
  let timestamp;
  let result;

  const later = (args1) => {
    // According to the last trigger interval
    const last = +new Date() - timestamp;

    // The last time the wrapped function was called,
    // the interval is last less than the set interval. wait
    if (last < wait && last > 0) {
      timeout = setTimeout(() => later(args1), wait - last);
    } else {
      timeout = null;
      // If it is set to immediate===true, since the start boundary has already been called,
      // there is no need to call it here.
      if (!immediate) {
        result = func.apply(context, args1);
        if (!timeout) context = args1 == null;
      }
    }
  };

  return function (...args1) {
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // If the delay does not exist, reset the delay
    if (!timeout) timeout = setTimeout(() => later(args1), wait);
    if (callNow) {
      result = func.apply(context, args1);
      context = args1 == null;
    }
    return result;
  };
}

export function throttle(fun, timeout = 500) {
  // 利用闭包保存定时器和上次执行时间
  // 上次执行时间
  let timer = null;
  let last;

  return function (...args) {
    const now = +new Date();

    if (last && now < last + timeout) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        last = now;
        fun.apply(this, args);
      }, timeout);
    } else {
      last = now;
      fun.apply(this, args);
    }
  };
}

let copying = false;
export function copyFun(val, tip, showTip = true) {
  try {
    if (copying) return;
    copying = true;
    const text = "" + val;
    const input = document.createElement("input");
    // 隐藏此输入框
    input.style.position = "fixed";
    input.style.clipPath = "polygon(0px 0px,0px 0px,0px 0px,0px 0px);";
    input.style.top = "10px";
    if (input) {
      input.setAttribute("readonly", "");
    }
    document.body.appendChild(input);
    if (input) {
      input.setAttribute("value", text);
    }
    input.select();
    if (document.execCommand("copy")) {
      document.execCommand("copy");
    }
    if (input) {
      document.body.removeChild(input);
    }
    showTip &&
      Message.success(
        tip || vm.$t("Datalang.Recharge_TITLE_copidsuccessfully") || "Copied!"
      );
  } catch (error) {
    console.log(error);
  } finally {
    copying = false;
  }
}
export function copytextAreaFun(val, tip, showTip = true) {
  try {
    if (copying) return;
    copying = true;
    const text = "" + val;
    const textarea = document.createElement("textarea");
    // 隐藏此文本域
    textarea.style.position = "fixed";
    textarea.style.clipPath = "polygon(0px 0px,0px 0px,0px 0px,0px 0px);";
    textarea.style.top = "10px";
    if (textarea) {
      textarea.setAttribute("readonly", "");
    }
    document.body.appendChild(textarea);
    textarea.value = text;
    // textarea.setAttribute("value", text);
    textarea.select();
    if (document.execCommand("copy")) {
      document.execCommand("copy");
    }
    if (textarea) {
      document.body.removeChild(textarea);
    }
    showTip &&
      Message.success(
        tip || vm.$t("Datalang.Recharge_TITLE_copidsuccessfully") || "Copied!"
      );
  } catch (error) {
    console.log(error);
  } finally {
    copying = false;
  }
}

// 锁定html滚动
export function lock() {
  document.documentElement.style.overflow = "hidden";
  document.documentElement.style.position = "fixed";
  document.body.scroll = "no";
}

// 解除html锁定
export function unLock() {
  document.documentElement.style.overflow = "";
  document.documentElement.style.position = "relative";
  document.body.scroll = "yes";
}
// 获取分享channel_id
export function getShareChannelId() {
  let params = window.localStorage.getItem("localInitQuery");
  if (params) {
    params = JSON.parse(params);
  }
  return (
    params?.channel_id ||
    Store.getters.getPacketConfig?.packet_config?.channel_id ||
    ""
  );
}
// 是否是马甲包访问
export function isFromApp() {
  return Boolean(window.localStorage.getItem("isFromApp"));
}
// 判断用户是否是web端注册
export function isWebAccount() {
  const user = Store.getters.user;
  return user?.device_type === 3;
}
// 判断用户是否是ios端注册
export function isIOSAccount() {
  const user = Store.getters.user;
  return user?.device_type === 2;
}
// 判断用户是否是andriod端注册
export function isAndroidAccount() {
  const user = Store.getters.user;
  return user?.device_type === 1;
}
// 生成分享链接
export function createShareUrl(url) {
  if (isFromApp() && url) {
    return url;
  }
  const user = Store.getters.user;
  const baseUrl = window.location.origin + "/home";
  // v1.19.8 分享邀请链接拼接时间戳
  const timestamp = new Date().getTime();
  return `${baseUrl}?uid=${user.inviteCode || ""}`;
}
export function isObject(obj) {
  return Object.prototype.toString.call(obj) === "[object Object]";
}
export function isString(obj) {
  return Object.prototype.toString.call(obj) === "[object String]";
}
/**
 * 格式化翻译
 * @param {string} lang 翻译后的语言 如：使用大于总赌注c%b%的赢取 c%g%或等额其他货币金额
 * @param {object | striing} replace 需要替换的k:v对象： 如：{'c%': 'p', 'b%': 10, 'g%': 100} 传单个值 则默认只会替换s%
 * @returns
 */
export function formatLanguage(lang, replace = null) {
  if (!lang || !replace) return lang;
  const defSyml = "s%";
  if (isObject(replace)) {
    Object.entries(replace).map((item) => {
      const [key, value] = item;
      lang = lang.replaceAll(key, value);
    });
  } else if (isString(replace) && lang.includes(defSyml)) {
    lang = lang.replaceAll(defSyml, replace);
  }
  return lang;
}

// 校验邮箱
export function validateEmail(a) {
  return /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/g.test(
    a + ""
  );
}

export function formattedValue(currentValue, decimal = 2, showThousand = true) {
  if (!currentValue) return currentValue;
  let formatted = Number(currentValue).toFixed(decimal);
  if (showThousand) {
    formatted = formatted.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return formatted;
}

export function cacheManage(data) {
  const keys = [
    "bottomNavigation",
    "homepage",
    "brand",
    "personalCenterTemplate",
    "h5top",
  ];
  // 清空所有缓存
  keys.forEach((key) => {
    localStorage.removeItem(`cache_${key}`);
  });
  // 根据data的key，缓存到localStorage
  Object.keys(data).forEach((key) => {
    console.log(key, "key");
    if (keys.includes(key)) {
      // 如果有数据则缓存
      if (data[key]) {
        localStorage.setItem(`cache_${key}`, JSON.stringify(data[key] || ""));
      }
    }
  });
}

export function getCacheData(key) {
  try {
    return JSON.parse(localStorage.getItem(`cache_${key}`));
  } catch (error) {
    return null;
  }
}

export function setCacheData(key, data) {
  localStorage.setItem(`cache_${key}`, JSON.stringify(data || ""));
}
// 处理关闭弹窗
export function dialogVisible() {
  //   console.log("dialogVisible");
}
// UTF-8 安全版 btoa
export function encodeBase64(str) {
  return window.btoa(unescape(encodeURIComponent(str)));
}
// UTF-8 安全版 atob
export function decodeBase64(str) {
  return decodeURIComponent(escape(window.atob(str)));
}
